module.exports = __webpack_public_path__ + "media/images/bus/conditions/ALRO-d59be2898137f6a7a6a5ce6fc4bb1faa.svg";